// extracted by mini-css-extract-plugin
module.exports = {"switch01":"switch_switch01__1QxQG","ball":"switch_ball__3b8ft","active":"switch_active__osjP6"};